<!-- Пункт бокового меню для страницы автопарка. -->
<template>
  <li
    v-if="canSeePage('fleet')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Fleet')"
    @mouseup="handleMiddleClick($event, 'Fleet')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Fleet')"
    :class="{ active: activeItem === 'fleet' }"
    :title="collapsed ? 'Автопарк' : ''"
  >
    <div class="link-icon_box">
      <AppIcon name="fleet" :size="24" />
    </div>
    <AppSidebarItemLabel
      label="Автопарк"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import AppIcon from "@/components/Icon/AppIcon.vue";
import { sidebarItemProps } from "@/composables/useSidebarItem";

export default {
  name: "FleetItem",

  components: {
    AppSidebarItemLabel,
    AppIcon,
  },

  props: sidebarItemProps,

  emits: ["navigate", "middle-click", "context-menu"],

  methods: {
    navigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    handleMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    showContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
